// extracted by mini-css-extract-plugin
export default {"modal_content":"SalonDetailSetting_modal_content__uMI7h","form":"SalonDetailSetting_form__lzIL0","warning":"SalonDetailSetting_warning__8pnyO"};